import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { Toaster } from "./components/ui/sonner";

import DashboardLayout from "./components/layout/DashboardLayout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import CalendarPage from "./pages/CalendarPage";
import Drafts from './pages/Drafts';
import Compose from "./pages/Compose";
import MediaLibrary from "./pages/MediaLibrary";
import Accounts from "./pages/Accounts";
import Hashtags from "./pages/Hashtags";
import Analytics from "./pages/Analytics";
import Team from "./pages/Team";
import Settings from "./pages/Settings";
import Admin from "./pages/Admin";

function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        
                        <Route path="/" element={<DashboardLayout />}>
                            <Route index element={<Navigate to="/dashboard" replace />} />
                            <Route path="dashboard" element={<Dashboard />} />
                            <Route path="calendar" element={<CalendarPage />} />
                            <Route path="drafts" element={<Drafts />} />
                            <Route path="compose" element={<Compose />} />
                            <Route path="media" element={<MediaLibrary />} />
                            <Route path="accounts" element={<Accounts />} />
                            <Route path="hashtags" element={<Hashtags />} />
                            <Route path="analytics" element={<Analytics />} />
                            <Route path="team" element={<Team />} />
                            <Route path="settings" element={<Settings />} />
                            <Route path="admin" element={<Admin />} />
                        </Route>

                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-right" richColors />
            </AuthProvider>
        </ThemeProvider>
    );
}

export default App;
